import styled, { css } from 'styled-components';
import { Link } from 'react-router-dom';
import { AcessibilityButton } from '~/components/Acessibility/Acessibility.styled';
import { HEADER_BANNER_CHIP } from '~/components/Header/headerBannerChip.styled';

export const Wrap = styled.div`
  display: flex;
  position: relative;
  z-index: 5;
  margin: 0;
  line-height: 0;
  overflow: visible;
`;

export const Trigger = styled(AcessibilityButton)`
  position: relative;
  z-index: 21;
  margin: 0;
`;

export const Panel = styled.div`
  position: absolute;
  top: 0;
  right: 0;
  z-index: 20;
  min-width: 228px;
  padding-top: ${HEADER_BANNER_CHIP.tamanho}px;
  background: transparent;
  opacity: ${({ $open }) => ($open ? 1 : 0)};
  visibility: ${({ $open }) => ($open ? 'visible' : 'hidden')};
  pointer-events: ${({ $open }) => ($open ? 'auto' : 'none')};
`;

export const PanelInner = styled.div`
  padding: 4px 6px 6px;
  border-radius: 0 0 8px 8px;
  background: ${({ $bg }) => $bg};
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.28);
`;

const itemStyles = css`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  width: 100%;
  min-height: 40px;
  padding: 8px 10px;
  border-radius: 6px;
  color: #ffffff;
  text-align: right;
  text-decoration: none;
  box-sizing: border-box;

  &:hover,
  &:active,
  &:focus {
    color: #ffffff;
    text-decoration: none;
    background: rgba(255, 255, 255, 0.16);
  }

  &:focus-visible {
    outline: 2px solid #ffffff;
    outline-offset: 0;
  }
`;

export const PanelLink = styled(Link)`
  ${itemStyles}
`;

export const PanelAnchor = styled.a`
  ${itemStyles}
`;

export const ItemLabel = styled.span`
  font-size: 13px;
  font-weight: 600;
  line-height: 1.2;
  letter-spacing: 0.04em;
  text-align: right;
`;
